import { render, staticRenderFns } from "./externalPartner.vue?vue&type=template&id=6b54da82"
import script from "./externalPartner.vue?vue&type=script&lang=js"
export * from "./externalPartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports